import { useAnnouncerStore } from '@/lib/announcer'

/** Visually hidden; speaks where a shortcut landed. Mounted once, globally. */
export function AnnouncerRegion() {
	const message = useAnnouncerStore(s => s.message)
	return (
		<output aria-live='polite' className='sr-only' data-testid='shortcut-announcer'>
			{message}
		</output>
	)
}
